import { ENVIRONMENTS, IWebEnvironment } from '@shared/interfaces';

/* eslint-disable @typescript-eslint/no-var-requires */
export const environment: IWebEnvironment = {
  env: ENVIRONMENTS.QA,
  production: false,
  isDebugMode: true,
  isSentryDebugMode: false,
  VERSION: require('../../../../package.json').version,
  CORE_VERSION: require('../../../../package.json').coreversion,
  API_URL: 'https://qa.foms.jic.echonlabs.com',
  WEB_URL: 'https://qa.foms.jic.echonlabs.com',
  WEB_DOMAIN: 'qa.foms.jic.echonlabs.com',
  API_DOMAIN: 'qa.foms.jic.echonlabs.com',
  SENTRY_DSN: process.env.NX_WEB_SENTRY_DSN,
};
